import React from "react";
import DoglinkElement from "./DoglinkElement";
import icons from "../helpers/icons";
import VismerKnappen from "./VismerKnappen";
import Error from "./Error";

const FiktivSearchResults = ({errorText, isLoading, antallTreff, hunder, loadMoreData, kjoenn, hundId, sisteHunder, favoritter}) => {
    //  list of searched dogs here

    const url = (partnerHundId) => {
        return process.env.REACT_APP_HUNDEWEB_ENDPOINT + "/hdb/openPage/stamtavle/fiktiv_stamtavle_hdb.html?" + (kjoenn === 'T' ? `HUIDMor=${hundId}&HUIDFar=${partnerHundId}` : `HUIDMor=${partnerHundId}&HUIDFar=${hundId}`)
    };
    const target = "_blank";

    const renderFavoritter = () => {
        if (favoritter === undefined || favoritter.length === 0) return null;

        const Favoritter = favoritter.map(f =>
            <DoglinkElement
                key={f.id}
                linkTo={url(f.hundId)}
                target={target}
                iconFirst={icons.fav}
                iconLast={icons.arb}
                data={f}
            />
        );
        return (
            <li>
                <strong>MINE FAVORITTER</strong>
                <ul>
                    {Favoritter}
                </ul>
            </li>
        )
    };

    const renderSisteHunder = () => {
        if (sisteHunder === undefined || sisteHunder.length === 0) return null;

        const SisteHunder = sisteHunder.map(f =>
            <DoglinkElement
                key={f.id}
                linkTo={url(f.hundId)}
                target={target}
                iconFirst={icons.bookmark}
                iconLast={icons.arb}
                data={f}
            />
        );

        return (
            <li>
                <strong>DE SENESTE VISTE HUNDE</strong>
                <ul>
                    {SisteHunder}
                </ul>
            </li>

        )
    };

    const renderResults = () => {
        if (errorText !== null)
            return <Error>{errorText}</Error>

        if ((sisteHunder === undefined || sisteHunder === null) && (favoritter === undefined || favoritter === null) && antallTreff === null)
            return null;




        const ret = hunder.map(res =>
            //const ret = hunder.map(res =>
            <DoglinkElement
                key={res.hundId}
                linkTo={url(res.hundId)}
                target={target}
                iconFirst={icons.bookmark}
                iconLast={icons.arb}
                data={res}
            />
        );


        return(
            <div className="results-container">
                <div className="results-list">
                    {
                        antallTreff !== null &&
                        <span className="antall">Antal: {antallTreff}</span>
                    }
                    <ul className="doglinks-list">
                        { ret }
                        <VismerKnappen
                            total={antallTreff}
                            maxStep="20"
                            renderedAmount={hunder.length}
                            incrementer={loadMoreData}
                        />

                        { antallTreff === null &&
                            renderFavoritter()
                        }

                        { antallTreff === null &&
                            renderSisteHunder()
                        }


                    </ul>
                </div>
            </div>
        )
    };

    return (
        <div className="results-container">
            { renderResults() }
        </div>
    )


};


export default FiktivSearchResults;